"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisualToggle = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisualToggle = function VisualToggle(_a) {
  var yoda = _a.yoda,
      sx = _a.sx,
      _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["yoda", "sx", "variant"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({}, props, {
    sx: (0, _tslib.__assign)({
      position: 'relative',
      width: '36px',
      height: '20px',
      borderRadius: '20px',
      backgroundColor: yoda ? 'primary' : 'muted',
      'input:checked ~ &': {
        backgroundColor: yoda ? 'muted' : 'primary',
        '> span': {
          right: yoda ? 'auto' : '3px',
          left: yoda ? '3px' : 'auto'
        }
      },
      'input[disabled] ~ &': {
        opacity: 0.5
      },
      variant: "forms." + variant + ".toggle"
    }, sx)
  }), _react.default.createElement(_Box.default, {
    as: "span",
    sx: {
      width: '14px',
      height: '14px',
      backgroundColor: 'white',
      borderRadius: '50%',
      display: 'block',
      position: 'absolute',
      top: '3px',
      left: yoda ? 'auto' : '3px',
      right: yoda ? '3px' : 'auto',
      variant: "forms." + variant + ".toggle.handle"
    }
  }));
};

exports.VisualToggle = VisualToggle;